import { useEffect, useMemo, useState } from 'react';

import Loader from '../../../components/Loader/Loader';
import { makeEnding } from '../../../core/formatters';
import { IconArrowRight, IconBack } from '../../../icons';
import Grid from '../../../components/Grid/Grid';
import { ContentRibbon } from '../../../core/models/ContentRibbon';
import Button from '../../../components/Button/Button';
import { iPublication } from '../../../core/models/Publication';
import useSearchResults from '../../../core/apiHooks/useSearchResults';
import { TAKE_MACS_COUNT } from './GlobalSearch';
import SearchResultsSectionSkeleton from './SearchResultsSectionSkeleton';

interface iMacsResultsProps {
    slideTilesCount: number;
    macsResultsCount: number;
    queryValue: string;
    inMyLibrary: boolean;
    macsResults: iPublication[];
    isLoading: boolean;
}

const MacsResults = ({
    slideTilesCount,
    macsResultsCount,
    queryValue,
    inMyLibrary,
    macsResults,
    isLoading
}: iMacsResultsProps) => {
    const [isMacsResultsOpened, setIsMacsResultsOpened] = useState(false);

    useEffect(() => {
        setIsMacsResultsOpened(false);
    }, [isLoading]);

    const {
        isLoading: isRestMacsLoading,
        data: { macsResults: restMacsResults }
    } = useSearchResults(queryValue, inMyLibrary, {
        takeMacs: isMacsResultsOpened ? 100 : 0,
        skipMacs: TAKE_MACS_COUNT
    });

    const macsResultsToRender = useMemo(() => {
        if (!isMacsResultsOpened) {
            return macsResults.slice(0, slideTilesCount);
        }

        return [...macsResults, ...restMacsResults];
    }, [isMacsResultsOpened, macsResults, restMacsResults, slideTilesCount]);

    if (isLoading) {
        return <SearchResultsSectionSkeleton title="Related MACs" tilesCount={slideTilesCount} />;
    }

    if (macsResults.length === 0) {
        return null;
    }

    return (
        <div className={`GlobalSearch__result ${isMacsResultsOpened ? 'collapsed' : ''}`}>
            <Grid
                columnsNumber={slideTilesCount}
                data={
                    new ContentRibbon({
                        clientModel: {
                            id: 2,
                            title: (
                                <>
                                    Related MACs
                                    <Button
                                        className="ShowAllButton"
                                        onClick={() => setIsMacsResultsOpened(!isMacsResultsOpened)}
                                    >
                                        {isMacsResultsOpened && <IconBack />}
                                        Show {isMacsResultsOpened ? 'less' : 'all'}
                                        {!isMacsResultsOpened && <IconArrowRight />}
                                    </Button>
                                </>
                            ),
                            subTitle: `found in ${macsResultsCount} ${makeEnding('report', macsResultsCount)}`,
                            items: macsResultsToRender
                        }
                    })
                }
            />
            {isRestMacsLoading && <Loader />}
        </div>
    );
};

export default MacsResults;
